import { DataMap } from '@shared/utils/dataMapping';
export function getGalleryPageTitle({ context, isConverged }) {
    return isConverged ? context.loc('MarketplaceServicesGallery_pageTitle', "All consulting services \u2013 Microsoft Marketplace") : context.loc('servicesGallery_pageTitle', "All consulting services \u2013 Microsoft AppSource");
}
export function getDetailsPageTitle({ context, isConverged, title }) {
    return isConverged ? context.locParams('MarketplaceDetail_pageTitle', [
        title
    ], `${title} - Microsoft Marketplace`) : context.locParams('detail_pageTitle', [
        title
    ], `${title} - Microsoft AppSource`);
}
export function getFilterItemRoute({ filterItem, filterValue, filterTileType }) {
    const filter = DataMap[`${filterItem}`][`${filterValue}`];
    const routeArgs = null;
    const params = {
        industry: null,
        category: null,
        product: null,
        search: null,
        serviceType: null
    };
    params[`${filterTileType}`] = filter.UrlKey;
    return {
        routeArgs,
        params
    };
}
export function isFilterItemMatch({ service, filterItem, filterValue }) {
    return service[`${filterItem}`] & DataMap[`${filterItem}`][`${filterValue}`].FilterID;
}
